module.exports = __webpack_public_path__ + "img/420-a79299.png";